<mat-chip-list>
	<mat-chip
		*ngFor="let sub of array.controls; let i = index"
		[color]="sub.value.isPrimary ? 'primary' : 'secondary'"
		[matTooltip]="sub.value.isPrimary ? 'Primary Contact' : ''"
		selected
		(click)="editEmailAddress(i)"
	>
		{{ sub.value.email }}
		<mat-icon
			matChipRemove
			rpsharedConfirm="Delete email address?"
			(onConfirmed)="array.removeAt(i)"
			>cancel</mat-icon
		>
	</mat-chip>
	<mat-chip
		color="primary"
		class="add-email-address-chip"
		(click)="addEmailAddress()"
	>
		Add
		<mat-icon matChipRemove>add</mat-icon>
	</mat-chip>
</mat-chip-list>
